import { omit } from 'lodash-es';
import {
  getPhotoConfig,
  DEFAULT_WIDTH,
  THUMBNAIL_WIDTH_MOBILE,
  THUMBNAIL_WIDTH_DESKTOP,
} from 'site-modules/shared/utils/inventory-image-utils';
import { ASPECT } from 'client/utils/inventory-image-helper';
import { PHOTO_TYPE } from 'client/engagement-handlers/inventory-engagement-handler/constants';

function getImageIndex(imagePath) {
  const indexMatch = imagePath.match(/\/img-(\d+)/);
  return indexMatch ? indexMatch[1] : null;
}

const injectPhotoMetadata = (photos, photosMetadata) => {
  const { photoUrls, photoType } = photos;
  const photosWithoutPhotoUrlsWithPhotoTypes = omit(photos, 'photoUrlsWithPhotoTypes');

  if (photoType !== PHOTO_TYPE.DEALER) {
    return {
      ...photosWithoutPhotoUrlsWithPhotoTypes,
      photoUrlsWithMetadata: photos.photoUrlsWithPhotoTypes,
    };
  }

  return {
    ...photosWithoutPhotoUrlsWithPhotoTypes,
    photoUrlsWithMetadata: photoUrls.map((photoUrl, index) => {
      const photoMetadata =
        photosMetadata &&
        photosMetadata.find(({ imagePath }) =>
          new RegExp(`img-${getImageIndex(imagePath)}(-[\\d\\w]+)*\\.`).test(photoUrl)
        );
      return {
        ...photos.photoUrlsWithPhotoTypes[index],
        url: photoUrl,
        ...omit(photoMetadata, 'imagePath'),
      };
    }),
  };
};

/**
 * Returns a list of photos available
 * @param {InventoryEntities} vinData - InventoryEntities
 * @param {Number} width - photo width
 * @param {Boolean} disableInventoryMLPhotoSort
 * @param {Boolean} isMobile
 * @param {Object} photosMetadata
 * @return {Object} object of Photo URLs and photo types
 */
export function getInventoryHeroPhotoConfig({
  vinData,
  width = DEFAULT_WIDTH,
  disableInventoryMLPhotoSort = false,
  isMobile,
  photosMetadata,
}) {
  const galleryPhotos = getPhotoConfig(vinData, width, null, disableInventoryMLPhotoSort);
  const thumbnailPhotos = getPhotoConfig(
    vinData,
    isMobile ? THUMBNAIL_WIDTH_MOBILE : THUMBNAIL_WIDTH_DESKTOP,
    // eslint-disable-next-line no-underscore-dangle
    ASPECT._16x7,
    disableInventoryMLPhotoSort,
    true
  );
  return { ...injectPhotoMetadata(galleryPhotos, photosMetadata), thumbnailPhotoUrls: thumbnailPhotos.photoUrls };
}
